export default "__VITE_ASSET__BJgQ$Aak__"